<template>
    <div class="c-shop-admin">
        <div class="inner-content full">
            <div v-if="!isSuperAdmin">
                U heeft geen toegang tot deze pagina
            </div>

            <div v-else>
                <div class="menu">
                    <span>Winkels</span> |
                    <router-link class="btn-basic small blue" to="/service-users">Service Users</router-link>
                </div>
                <div class="shop-content">
                    <div class="shops">
                        <button class="btn-basic small blue" @click.prevent="clickShowCreateShop">Winkel aanmaken</button>
                        <button v-for="shop in shops" :key="shop.id" class="btn-list btn-basic small bordered"
                            :ref="'shop'+ shop.id"
                            :class="{selected : selectedShop != null && selectedShop.id == shop.id}"
                            @click.prevent="selectedShop = shop">
                            {{shop.name}}
                        </button>
                    </div>

                    <div class="shop-detail" v-if="selectedShop != null">
                        <div class="title">
                            <input type="text" class="inputfield" v-model="selectedShop.name"/>
                        </div>
                        <div class="detail-row">
                            Shop id : {{selectedShop.id}}
                        </div>
                        <div class="detail-row">
                            <Checkbox v-model:checked="selectedShop.has_demo_beds" label="Demo bedden actief"/>
                        </div>
                        <div class="detail-row">
                            <Checkbox v-model:checked="selectedShop.show_service_type" label="Toon Service afspraak keuze"/>
                        </div>
                        <div class="detail-row">
                            <Checkbox v-model:checked="selectedShop.dashboard_to_sf" label="Sync afspraken van Dashboard naar Salesforce"/>
                        </div>
                        <div class="detail-row">
                            <Checkbox v-model:checked="selectedShop.sf_to_dashboard" label="Sync van Salesforce naar Dashboard"/>
                        </div>
                        <div class="detail-row">
                            <button class="btn-basic btn-save small blue" @click.prevent="saveShopSettings">
                                Opslaan
                            </button>
                            <div v-if="feedback" class="feedback">
                                Wijzigingen opgeslagen
                            </div>
                            <div v-if="shopError" class="form-error">
                                {{shopError}}
                            </div>
                        </div>

                        <div class="title">Logins</div>
                        <div v-if="editUser == null">
                            <div v-for="user in users" :key="user.id" class="user-row">
                                <span>{{user.name}}</span>
                                <span>{{user.email}}</span>
                                <span>(<i>{{user.role}}</i>)</span>
                                <span class="action-buttons">
                                    <button class="btn-delete-user btn-basic small blue" @click.prevent="clickEditUser(user)">bewerken</button>
                                    <button class="btn-delete-user btn-basic small red" @click.prevent="clickDeleteUser(user)">wissen</button>
                                </span>
                            </div>
                            <button class="btn-basic small blue" @click.prevent="clickShowCreateUser">
                                Gebruiker Toevoegen
                            </button>
                        </div>
                        <div v-else class="create-user">
                            <div class="role">
                                <input type="radio" name="role" v-model="editUser.role" value="admin">Admin
                                <input type="radio" name="role" v-model="editUser.role" value="sales">Sales
                            </div>
                            <input autocomplete="off" type="text" class="inputfield" placeholder="naam" v-model="editUser.name" :class="{error : nameError}"/>
                            <input autocomplete="off" type="text" class="inputfield" placeholder="email" v-model="editUser.email" :class="{error : emailError}"/>
                            <input autocomplete="off" type="password" class="inputfield" placeholder="Wachtwoord" v-model="editUser.password" :class="{error : passwordError || passwordSizeError}"/>
                            <input autocomplete="off" type="password" class="inputfield" placeholder="Bevestig Wachtwoord" v-model="editUser.password2" :class="{error : passwordError}"/>
                            <div v-if="userFormError" class="form-error">
                                {{userFormError}}
                            </div>

                            <button class="btn-basic small blue" @click.prevent="clickCreateUser">
                                {{isNewUser ? "Toevoegen" : "Opslaan"}}
                            </button>
                            <button class="btn-cancel-add btn-basic small bordered" @click.prevent="editUser = null">
                                Annuleren
                            </button>
                        </div>
                    </div>

                    <div class="shop-detail" v-if="showCreateShop">
                        <div class="title">Winkel aanmaken</div>
                        <br/>
                        <div class="formfield">
                            <input type="text" class="inputfield" placeholder="naam" v-model="newShop.name"/>
                        </div>
                        <button class="btn-basic blue small" @click.prevent="clickCreateShop">Aanmaken</button>

                    </div>
                </div>
            </div>
        </div>
        <div class="popup" v-if="userToDelete != null">
            <div class="popup-content">
                <div class="title">
                    Wil je deze gebruiker verwijderen?
                </div>
                <div class="buttons">
                    <button @click.prevent="cancelDeleteUser" class="btn-basic small bordered">annuleren</button>
                    <button @click.prevent="confirmDeleteUser" class="btn-basic small red">wissen</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Checkbox from "@/components/Checkbox.vue";
import {apiStore} from "@/stores/api";
import {isValidEmail} from "@/utils/utils.js";

export default {
    name : "ShopAdmin",

    components: {
        Checkbox
    },

    data() {
        return {
            user : null,
            shops: [],
            selectedShop : null,
            showCreateShop : false,
            newShop : {
                name : ""
            },
            users : [],
            editUser : null,
            isNewUser : false,
            nameError : false,
            emailError : false,
            passwordError : false,
            passwordSizeError : false,
            userFormError : null,
            userToDelete : null,
            shopError : null,
            feedback: false
        };
    },

    computed: {
        isSuperAdmin() {
            return apiStore().loggedInUser !== null && apiStore().loggedInUser.role === "superadmin";
        }
    },

    async created() {
        this.getShops();
    },

    watch: {
        async selectedShop() {
            this.showCreateShop = false;
            this.feedback = false;
            if (this.selectedShop !== null) {
                this.getUsers();
                this.editUser = null;
            }
        }
    },

    methods: {
        async getShops() {
            this.shops = await apiStore().getShops();
        },

        clickShowCreateShop() {
            this.selectedShop = null;
            this.newShop = {
                name : ""
            };
            setTimeout(() => {
                this.showCreateShop = true;
                this.$forceUpdate();
            }, 100);
        },

        async clickCreateShop() {
            const slots = new Array(7).fill([{"from" : "10:00", "to":"17:00"}]);
            this.newShop.hours = JSON.stringify({slots, duration:15});
            const shop = await apiStore().createShop(this.newShop);
            await this.getShops();
            this.showCreateShop = false;
            this.selectedShop = shop;

            this.$nextTick(() => {
                const btns = this.$refs["shop" + shop.id];
                if (btns.length > 0) {
                    btns[0].scrollIntoView({behavior: "smooth", block: "center", inline: "nearest"});
                }
            });
        },

        async clickSaveShop() {
            await apiStore().updateShop(this.selectedShop);

        },

        clickShowCreateUser() {
            this.isNewUser = true;
            this.editUser = {
                role : "admin",
                name : "",
                email : "",
                password: "",
                password2: ""
            };
        },

        async getUsers() {
            this.users = await apiStore().getUsersForShop(this.selectedShop.id);
        },

        async clickCreateUser() {
            this.userFormError = null;
            this.nameError = false;
            this.emailError = false;
            this.passwordSizeError = false;
            this.passwordError = false;

            if (this.editUser.name === "") {
                this.nameError = true;
                this.userFormError = "Naam niet ingevuld";

            } else if (!isValidEmail(this.editUser.email)) {
                this.emailError = true;
                this.userFormError = "Ongeldig E-mail adres";

            }

            if (this.isNewUser && this.editUser.password.trim() === "") {
                this.passwordSizeError = true;
                this.userFormError = "Wachtwoord niet ingevuld";
            }

            if (this.editUser.password.trim() !== "" || this.editUser.password2.trim() !== "") {
                if (this.editUser.password.length < 8) {
                    this.passwordSizeError = true;
                    this.userFormError = "Wachtwoord moet min 8 karakters bevatten";

                } else if (this.editUser.password !== this.editUser.password2) {
                    this.passwordError = true;
                    this.userFormError = "Wachtwoorden komen niet overeen";
                }
            }

            if (this.userFormError === null) {
                let result = null;
                if (this.isNewUser) {
                    result = await apiStore().createUserForShop(this.selectedShop.id, this.editUser);

                } else {
                    result = await apiStore().updateUser(this.editUser);
                }

                if (result.error !== undefined) {
                    this.userFormError = "Gebruiker of E-mail wordt al gebruikt";
                    return;
                }

                await this.getUsers();
                this.editUser = null;
            }
        },

        clickDeleteUser(user) {
            this.userToDelete = user;
        },

        clickEditUser(user) {
            this.editUser = user;
            this.editUser.password = "";
            this.editUser.password2 = "";
            this.isNewUser = false;
        },

        async confirmDeleteUser() {
            await apiStore().deleteUser(this.userToDelete.id);
            this.userToDelete = null;

            await this.getUsers();
        },

        cancelDeleteUser() {
            this.userToDelete = null;
        },

        async saveShopSettings() {
            this.feedback = false;
            this.shopError = null;

            if (this.selectedShop.name.trim() === "") {
                this.shopError = "Winkelnaam mag niet leeg zijn";
                return;
            }
            await apiStore().updateShop(this.selectedShop);
            this.feedback = true;
        }
    }
};
</script>

<style lang="scss" scoped>
.c-shop-admin {
    input[type=text].inputfield,
    input[type=password].inputfield {
        height : 2rem;
        font-size: 1em;
        width : 20rem;
    }

    .inner-content {
        padding-top : 0;
    }

    .menu {
        margin-bottom : 1rem;

        span {
            font-weight: bold;
        }

        a {
            background: transparent;
            color: black;
            border: none;
            padding: 0;
            text-decoration: underline;
            font-size: 1em;
        }
    }

    .shop-content {
        display : flex;
    }

    .action-buttons {
        display: flex;
        gap : .5rem;
    }

    .shops {
        width : 20%;
        display: flex;
        flex-direction: column;
        max-height: 65vh;
        overflow-y: scroll;

        .btn-basic {
            margin-bottom : .5rem;
        }
    }

    .btn-list {
        &.selected {
            background : #ddd;
        }
    }

    .shop-detail {
        width : 75%;
        margin-left : 5%;
        overflow-y: scroll;

        .title {
            font-size : 1.5em;
            font-weight : bold;
            margin-bottom: .5rem;
        }

        .detail-row {
            margin-bottom : .5rem;
        }

        .btn-save {
            margin-bottom : 1rem;
        }

        .feedback {
            color : $color-green;
            font-weight: bold;
            margin-bottom : 1.2rem;
        }
    }

    .user-row {
        margin-bottom : .5rem;
        font-size : 1.25em;

        display: flex;
        display: flex;
        align-items: center;
        justify-content: space-between;

        span {
            width : 25%;
        }
    }

    .create-user {
        .inputfield {
            display : block;
        }
    }

    .form-error {
        color : $color-red;
        margin-bottom : 2rem;
    }

    .role {
        margin-bottom : 1rem;
        input {
            height : 1rem;
            width : 1rem;
        }
    }

    .popup {
        position: absolute;
        background : rgba(255, 255, 255,.8);
        top : 0;
        left : 0;
        right : 0;
        bottom : 0;
        display: flex;
        align-items: center;
        justify-content: center;
        text-align: center;

        .buttons {
            .btn-basic {
                margin : 1rem;
            }
        }
    }

    .btn-cancel-add {
        margin-left : 1rem;
    }
}
</style>